var map = {
	"./CustomPackage/langs": "ifjG",
	"./GlobalBPOCore/langs": "N3aw",
	"./SelfService/langs": "AiSI",
	"./SteelOApp/langs": "b5DJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tL7r";


//////////////////
// WEBPACK FOOTER
// ./src/customization ^\.\/.*\/langs$
// module id = tL7r
// module chunks = 0